<template>
  <div class="main-content sn-content">
      <el-card style="margin: 0 auto">
      <el-form :rules="rules" :model="form" ref="form" width="500px" style="max-width: 500px" label-position="left"
               label-width="90px" v-loading="loading" auto-complete="off">
        <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>
        <el-form-item prop="captcha" label="图形验证码">
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" style="padding: 0 !important;">
            <el-input type="text" v-model="captcha" auto-complete="off" placeholder="图形验证码"></el-input>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <a class="" href="javascript:void(0);"><img v-on:click="change()" ref="captcha"
                                                        class="captcha" style="position: absolute;padding: 0px 20px 0"/></a>
          </el-col>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号">
          <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
            <el-input v-model="form.mobile" auto-complete="off" placeholder="手机号" class="input-with-select">
              <el-select v-model="form.countryMob" slot="prepend" placeholder="请选择" class="country-mobile-select">
                <el-option v-for="item in countryList" :key="item.value" :value="item.value">{{item.label}}&nbsp;&nbsp;{{item.value}}</el-option>
              </el-select>
            </el-input>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" class="sendBtn send-btn" style="line-height: 40px">
            <smsCode :mobile="form.mobile" type="2" :countryMob="form.countryMob" :captcha="captcha" :captchaId="captchaId" @changeCaptcha="change"></smsCode>
          </el-col>
        </el-form-item>
        <el-form-item prop="smsCode" label="验证码">
          <el-input class="col-md-12" type="text" v-model="form.smsCode" auto-complete="off"
                    placeholder="验证码"></el-input>
          <el-input type="text" style="position: fixed;bottom: -9999px"></el-input>
        </el-form-item>

        <el-form-item prop="oldPassword"  label="原密码">
          <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>
          <el-input class="col-md-12" onfocus="this.type='password'" v-model="form.oldPassword" auto-complete="off"
                    placeholder="原密码"></el-input>
        </el-form-item>
        <el-form-item prop="password"  label="新密码">
          <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>
          <el-input class="col-md-12"  onfocus="this.type='password'" v-model="form.password" auto-complete="off"
                    placeholder="设置密码"></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" label="确认密码">
          <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>
          <el-input class="col-md-12" onfocus="this.type='password'" v-model="form.confirmPassword" auto-complete="off"
                    placeholder="确认密码"></el-input>
        </el-form-item>

        <el-form-item>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-button type="primary" class="pxy-primary" @click.native.prevent="updatePassword">修改</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      </el-card>
  </div>
</template>
<script>
  import {Message} from "element-ui";
  import smsCode from '@/components/smsCodeComponent'
  const countryList = [
    {label: '中国/China', value: '+86'},
    {label: '中国香港/Hong Kong', value: '+852'},
    {label: '中国台湾/Taiwan', value: '+886'},
    {label: '中国澳门/Macao', value: '+853'},
    {label: '澳大利亚/Austria', value: '+61'},
    {label: '加拿大/Canada', value: '+1'},
    {label: '瑞士/Switzerland', value: '+41'},
    {label: '德国/Germany', value: '+49'},
    {label: '丹麦/Denmark', value: '+45'},
    {label: '法国/France', value: '+33'},
    {label: '英国/United Kingdom', value: '+44'},
    {label: '爱尔兰/Ireland', value: '+353'},
    {label: '意大利/Italy', value: '+39'},
    {label: '日本/Japan', value: '+81'},
    {label: '韩国/South Korea', value: '+82'},
    {label: '开曼群岛/Cayman Islands', value: '+1345'},
    {label: '马尔代夫/Maldives', value: '+960'},
    {label: '墨西哥/Mexico', value: '+52'},
    {label: '马来西亚/Malaysia', value: '+60'},
    {label: '荷兰/Netherlands', value: '+31'},
    {label: '挪威/Norway', value: '+47'},
    {label: '新西兰/New Zealand', value: '+64'},
    {label: '新加坡/Singapore', value: '+65'},
  ]
  export default {
    components: {smsCode},
    mounted: function () {
       this.change();
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        }else if (this.form.confirmPassword != '' && value != this.form.confirmPassword) {
          console.log(this.form.confirmPassword)
          callback(new Error('两次输入密码不一致!'));
        }
        callback();
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      }
      return {
        baseUrl: this.$apiUrl,
        rules: {
          oldPassword:[  {required: true, message: '请输入原密码', trigger: 'blur' }],
          password: [  {required: true, validator: validatePass, trigger: 'blur' }],
          smsCode: [{required: true, message: '请输入验证码', trigger: 'blur'}],
          mobile: [{required: true, message: '请输入手机号', trigger: 'blur'}],
          confirmPassword: [  {required: true, validator: validatePass2, trigger: 'blur' }],

        },
        form: {
          mobile: '',
          password: '',
          oldPassword:'',
          smsCode: '',
          role: 1,
          confirmPassword:'',
          countryMob: '+86'
        },
        captcha:'',
        captchaId:'',
        loading: false,
        countryList: countryList
      }
    },
    methods: {
      change: function () {
        this.getRequest('/uacUser/captcha', {'d': new Date().getTime(), "base64": "1"}).then(resp => {
          this.$refs.captcha.src = resp.data.result;
          this.captchaId = resp.headers.captchaid;
          /*        this.$refs.captcha1.src = resp.data.message;*/
          /*  $(".captcha").attr('src',resp.data.message)*/
        })
      },
      updatePassword: function () {
        var _this = this;
        var params = {};
        params.oldPassword = this.form.oldPassword
        params.newPassword = this.form.password;
        params.smsCode = this.form.smsCode;
        params.mobile = this.form.countryMob==='+86' ? this.form.mobile : this.form.countryMob + this.form.mobile
        params.userId = this.$store.state.user.userId
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/uacUser/changePassword', JSON.stringify(params)).then(resp => {
              _this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  Message.success(data.message);
                  this.form = {
                    mobile: '',
                    password: '',
                    oldPassword:'',
                    smsCode: '',
                    confirmPassword:''
                  }
                } else {
                  Message.error(data.message);
                }

              }
            });
          }
        })
      },
    },
    destroyed() {
      document.onkeydown = undefined
    }
  }
</script>
<style>


</style>
